import { NextRouter } from "next/router";
import { useCallback } from "react";

export const useRouteToFromConfigurator = (router: NextRouter) => {
  const routeToFromConfigurator = useCallback(
    (url: string, options?: { shallow?: boolean }) => {
      router.push(url, undefined, options);
    },
    [router]
  );

  return { routeToFromConfigurator };
};
